<template>
  <div>
    <Modal v-model="visible" width="1000px" title="业务员" :footer-hide="true" :mask-closable="false" class="my-modal top">
      <div class="search-box min">
        <div class="input-item">
          <span class="label">工号</span>
          <Input v-model="searchParams.staffNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">姓名</span>
          <Input v-model="searchParams.name" placeholder="请输入" clearable />
        </div>
        <!-- <div class="input-item">
        <span class="label">机构/团队</span>
        <selectTree type="2" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
      </div> -->
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
        </div>
      </div>
      <div class="table-box">
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="name">
            <span :class="row.workingState == 1 ? 'opening' : 'close'"></span>{{ row.name }}
          </template>

          <template slot-scope="{ row }" slot="organizationName">
            <span :class="row.orgStatus == 1 ? 'opening' : 'close'"></span>{{ row.organizationName }}
            <span>/</span> 
            <!-- <span :class="row.orgStatus == 1 ? 'opening' : 'close'"></span> -->
            {{ row.groupName }}
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
            style="text-align: center" />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { pageTool } from "@/api/mixins";
import selectTree from "@/components/system/selectTree3";
export default {
  mixins: [pageTool],
  components: {
    selectTree
  },
  props: [],
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        name: "",
        resignTime: null,
        reason: "",
      },
      columns: [
        {
          title: "序号",
          type: "index",
          minWidth: 120,
          align: "center",
        },
        {
          title: "工号",
          key: "staffNo",
          align: "center",
          minWidth: 120,
        },
        {
          title: "业务员名称",
          slot: "name",
          align: "center",
          minWidth: 120,
        },
        {
          title: "所属机构/团队",
          slot: "organizationName",
          align: "center",
          minWidth:160,
        },
        {
          title: "所属团队",
          key: "groupName",
          align: "center",
          minWidth:160,
        },
        {
          title: "人员状态",
          key: "workingState",
          align: "center",
          width:100,
          tooltip: true,
          render(h, params) {
            const type = params.row.workingState;
            if (type === "0") {
              return <span>离职</span>;
            }
            if (type === "1") {
              return <span>在职</span>;
            }
          },
        },
      ],
    };
  },

  methods: {
    open(data = {}) {
      this.searchParams.rankId = data.id;
      this.visible = true;
      this.initListAjax("/buz/baseRank/read/queryUsers");
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {//机构
        this.searchParams.organizationId = data.id;
        this.searchParams.groupId = "";
      } else if (data.nodeType == 2) {//团队
        this.searchParams.organizationId = "";
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.organizationId = "";
        this.searchParams.groupId = "";
      }
    },
    submit() {
      console.log("validate")
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        formData.resignTime = this.$units.formatDate(formData.resignTime, "yyyy-MM-dd");
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.$http({
          type: "POST",
          url: "/buz/userBase/dimission",
          data: formData
        }).then(res => {
          this.$notice.success("提交成功");
          this.visible = false;
          this.$emit("suceess")
        }).finally(res => {
          this.loading = false;
        });
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.close,
.opening {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 4px;
}


.close {
  background: #E36767;
}

.opening {
  background: #35BF3F;
}

.tools-box {
  text-align: right;
  line-height: 1.5;
  margin-bottom: 10px;
}

.search-box {
  margin-top: 10px;

  /deep/ .ivu-input {
    font-size: 13px;
  }

  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    font-size: 13px;
  }
}
</style>
